var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonClass,attrs:{"type":"button"},domProps:{"innerHTML":_vm._s(_vm.buttonContent)},on:{"click":function($event){return _vm.showAlert()}}})}
var staticRenderFns = []

export { render, staticRenderFns }